<mat-icon *ngIf="status.icon" [svgIcon]="status.icon" class="cl-status-icon" [ngClass]="status.klass"></mat-icon>
<mat-icon *ngIf="status.materialIcon" class="cl-status-icon" [ngClass]="status.klass">{{status.materialIcon}}</mat-icon>
<span>{{ status.statusText }}</span>
